// Single source of truth for the building-group onboarding wizard steps.
//
// The journey spans two routes/components:
//   - createBuildingGroup -> AssetCreateWizard   : steps 1-2 (address+type, buildings)
//   - createBuilding       -> BuildingConfigWizard: steps 3-5 (documents, properties, fiabilisation)
//
// Levels are no longer created in the wizard — they are inferred from the uploaded
// documents later. Keep this list in sync with both wizards. The progress indicator
// (WizardStepHeader) renders "Étape N sur TOTAL_WIZARD_STEPS".
export const ONBOARDING_STEPS = [
  'address', // 1 — address + building type (AssetCreateWizard / BuildingGroupCreateForm)
  'buildings', // 2 — create buildings (AssetCreateWizard / BuildingCreateForm)
  'documents', // 3 — add documents (BuildingConfigWizard, skippable)
  'properties', // 4 — review properties (BuildingConfigWizard, skippable)
  'fiabilisation', // 5 — Data Reliability module, final step (BuildingConfigWizard, non-blocking — spec §3.1)
] as const

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number]

export const TOTAL_WIZARD_STEPS = ONBOARDING_STEPS.length // 5

// Step ranges owned by each wizard component.
export const GROUP_WIZARD_STEPS = { min: 1, max: 2 } as const // AssetCreateWizard
export const CONFIG_WIZARD_STEPS = { min: 3, max: 5 } as const // BuildingConfigWizard

// Clamp a (possibly stale / out-of-range) resume step into [min, max].
export function clampStep(step: number | undefined, min: number, max: number): number {
  if (!step || Number.isNaN(step)) return min
  return Math.min(max, Math.max(min, step))
}
